import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/DoorAccess/enterpriseaccesshub.jpg.mjs';
import '../../assets/product-list-assets/cameras/door-access/enterprise-access-hub.jpg.mjs';
import { controlHubs } from '../product-list-groups/controlHubs.mjs';
import { accessPowerMethod } from '../properties/accessPowerMethod.mjs';
import { inputTerminals } from '../properties/inputTerminals.mjs';
import { outputRelays } from '../properties/outputRelays.mjs';
import { poePorts } from '../properties/poePorts.mjs';
import { powerRedundancy } from '../properties/powerRedundancy.mjs';
import v3Image__default from "../../../../assets/enterpriseaccesshub.jpg";
import image__default from "../../../../assets/enterprise-access-hub.jpg";
"use strict";
const enterpriseAccessHub = {
  id: "enterpriseAccessHub",
  productTitle: "Enterprise Access Hub",
  description: "enterpriseAccessHub.description",
  productListGroup: controlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/eah-8"],
  storePathParts: {
    category: "all-door-access",
    productSlug: "eah-8"
  },
  descriptionMaxWidth: 247,
  image: {
    src: image__default,
    width: 200,
    height: 160
  },
  v3Image: {
    src: v3Image__default,
    width: 257,
    height: 182
  },
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '379 x 355 x 105 mm\n(15 x 14 x 4.1")'
    }
  }, {
    propertyId: outputRelays.id,
    value: {
      type: "translation",
      value: "enterpriseAccessHub.outputRelays"
    }
  }, {
    propertyId: inputTerminals.id,
    value: {
      type: "translation",
      value: "enterpriseAccessHub.inputTerminals"
    }
  }, {
    propertyId: poePorts.id,
    value: {
      type: "translation",
      value: "enterpriseAccessHub.poePorts"
    }
  }, {
    propertyId: accessPowerMethod.id,
    value: {
      type: "translation",
      value: "commons.powerMethod.acPower"
    }
  }, {
    propertyId: powerRedundancy.id,
    value: {
      type: "translation",
      value: "enterpriseAccessHub.powerRedundancy"
    }
  }]
};
export { enterpriseAccessHub };
//# sourceMappingURL=enterpriseAccessHub.mjs.map
